import {
    ApolloClient,
    InMemoryCache,
    createHttpLink,
} from "@apollo/client/core";
import { setContext } from "@apollo/client/link/context";
import { WORKFLOW_API } from "@/config";

const httpLink = createHttpLink({
  uri: `${WORKFLOW_API}/graphql`,
});

const authLink = setContext((_, { headers }) => {
  const userData = sessionStorage.getItem("userLogin");
  const token = userData ? JSON.parse(userData).token : null;
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  };
});

const cache = new InMemoryCache();

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
});

export { apolloClient };
